<div *ngIf="!hideCategory" id="nav-cat">
  <ul class="header-category-list container-large container-fluid d-flex-center hidden-md">
    <li *ngFor="let category of categories">
      <a [routerLink]="['/' + (language == 'en' ? 'en' : ''), category?.link_category]" title="{{category?.name}}">
        <h2> <i class="{{categoriesStyles[currentCity][category?.id]}}"></i>{{category?.name}}</h2>
      </a>
    </li>
    <li>
      <button class="link-more viewAllBox" (click)="openModal('categories-modal')"
        style="margin:0; color: #2E4765; font-weight: 600;" attr.aria-label="{{this.language == 'bg' ? 'Бутон за попъп с категории' : 'Button for modal with all categories'}}">
        {{this.word[this.language]?.all}}<i class="fa fa-chevron-right" aria-hidden="true" ></i>
      </button>
    </li>
  </ul>
</div>
<categories-modal id="categories-modal">
  <div class="modal-header">
    <h1>{{this.word[this.language]?.allcatvenues}}</h1>
    <span class="close-modal"><i class="fa fa-times-circle" aria-hidden="true" (click)="closeModal('categories-modal')"></i></span>
  </div>
  <hr class="gray-line">
  <div class="categories-list">
    <div *ngFor="let category of categoriesList?.types | slice:1" class="category-box" (click)="closeModal('categories-modal')">
      <a [routerLink]="['/', category.link_type]"  title="{{category.name}}">
        <p>{{category.type}}</p>
      </a>
      <a [routerLink]="['/', category.link_type]" *ngIf="this.language == 'en'" title="{{category.type_uk}}">
        <p>{{category.type_uk}}</p>
      </a>
    </div>
  </div>
</categories-modal>
